export default {
  // Labels sueltos especificos del modulo exhibitions
  subtitle: 'Continuidad de exhibiciones',
  filteredResults: 'Resultados de tu búsqueda con Filtros',
  elapsedDays: 'Días transcurridos:',
  daysUnit: 'días',
  folioPrefix: 'No.',
  noResults: 'Sin resultados',
  cancel: 'Cancelar',

  // Labels de estado (badges/filtro de status)
  status: {
    all: 'Todas',
    active: 'Activas',
    finished: 'Finalizadas',
    activeBadge: 'Activa',
    finishedBadge: 'Finalizada',
    label: 'Estatus'
  },

  // Labels de la vista de detalle de una exhibicion
  detail: {
    title: 'Continuidad de exhibición',
    promoter: 'Promotor',
    supervisor: 'Supervisor',
    type: 'Tipo de Exhibición',
    location: 'Ubicación',
    place: 'Lugar de Exhibición',
    date: 'Fecha',
    elapsedDays: 'Días transcurridos',
    // TKT-1575 p5-026 (2026-09-02): unificado con status.label/sort.status, mismo
    // concepto con 2 palabras distintas en es ('Estado' vs 'Estatus'); en-us ya
    // era 'Status' en las 3.
    state: 'Estatus',
    addEvidence: 'Agregar evidencias',
    evidence: 'Evidencias',
    viewLog: 'Ver bitácora',
    finalize: 'Finalizar',
    log: 'Bitácora'
  },

  // Labels del formulario de creacion/edicion de exhibicion
  form: {
    title: 'Nueva Exhibición',
    content: 'Contenido de la Exhibición',
    searchCatalog: 'Buscar del catálogo...',
    type: 'Tipo de Exhibición',
    selectType: 'Selecciona un tipo',
    location: 'Ubicación',
    place: 'Lugar de Exhibición',
    placeHint: 'Ej. Pasillo de abarrotes',
    promoter: 'Asigna un Promotor',
    selectUser: 'Selecciona usuario',
    addEvidence: 'Agregar evidencias',
    create: 'Crear'
  },

  // Mensajes de validacion con redaccion especifica de exhibitions
  validation: {
    title: 'No se puede crear esta Exhibición',
    close: 'Cerrar',
    prefix: 'Para completar esta exhibición, {reason}',
    content: 'favor de seleccionar Contenido de la Exhibición.',
    type: 'favor de seleccionar Tipo de Exhibición.',
    location: 'favor de seleccionar Ubicación.',
    promoter: 'favor de asignar un Promotor.',
    evidence: 'favor de agregar evidencia fotográfica.'
  },

  // Textos de dialogos de confirmacion
  confirm: {
    createTitle: '¿Deseas crear esta exhibición?',
    createMessage: 'Se creará la exhibición, no se podrán realizar cambios.',
    finalizeTitle: '¿Finalizar exhibición?',
    finalizeMessage: 'Se registrará la fecha de cierre y no podrás agregar más evidencia.'
  },

  // Toasts de exito/error de acciones de exhibitions
  messages: {
    created: 'Exhibición creada con éxito',
    createError: 'No se pudo crear la exhibición',
    loadError: 'No se pudo cargar el listado, puede estar desactualizado',
    evidenceAdded: 'Evidencia agregada',
    evidenceError: 'No se pudo agregar la evidencia',
    evidenceRemoved: 'Evidencia eliminada',
    evidenceRemoveError: 'No se pudo eliminar la evidencia',
    finalized: 'Exhibición finalizada con éxito',
    finalizeError: 'No se pudo finalizar la exhibición'
  },

  // Labels del panel de filtros del listado de exhibitions
  filters: {
    title: 'Filtros',
    location: 'Ubicación',
    responsible: 'Responsable',
    product: 'Producto',
    searchProduct: 'Buscar',
    clearAll: 'Borrar todos los filtros',
    sort: 'Ordenar',
    showResults: 'Mostrar Resultados'
  },

  // Labels del panel de ordenamiento del listado de exhibitions
  sort: {
    title: 'Selecciona el ordenamiento',
    sortBy: 'Ordenar por:',
    fieldTitle: 'Título',
    responsible: 'Responsable',
    location: 'Ubicación',
    status: 'Estatus',
    createdAt: 'Fecha de Creación',
    asc: 'Ascendente',
    desc: 'Descendente',
    addCriterion: 'Agregar filtro',
    clearCriteria: 'Eliminar filtros',
    apply: 'Ordenar'
  },

  // Labels del selector de ubicacion
  location: {
    search: 'Buscar una ubicación',
    loading: 'Cargando ubicaciones...',
    selectedPrefix: 'Se ha seleccionado',
    selectedSuffix: 'como Ubicación.',
    changeIntro: 'Haz',
    changeLink: 'click aquí',
    changeOutro: 'para cambiar la ubicación.'
  },

  // Evidencia de exhibitions
  evidence: {
    maxReached: 'Máximo {max} fotos por carga.'
  },

  // Bitacora/log de una exhibicion
  log: {
    created: 'creó esta Exhibición en:',
    picture: 'adjuntó una evidencia:',
    deleted: 'eliminó una evidencia:',
    deletedMessage: 'Se eliminó una evidencia.',
    finished: 'finalizó esta Exhibición:',
    datePrefix: 'Fecha:',
    finishedMessage: 'Se ha finalizado la exhibición.',
    viewMore: 'Ver más',
    imageName: 'Imagen',
    empty: 'Sin registros en la bitácora.',
    user: 'Usuario'
  },

  // Labels del panel admin de catalogo/exhibitions
  admin: {
    tabCatalog: 'Catálogo',
    tabExhibitions: 'Exhibiciones',
    save: 'Guardar',
    empty: 'Sin registros.',
    saved: 'Guardado con éxito',
    saveError: 'No se pudo guardar',
    deleted: 'Registro eliminado',
    deleteError: 'No se pudo eliminar',
    deleteConfirmTitle: 'Eliminar registro',
    deleteConfirmMessage: '¿Seguro que deseas eliminar este registro?',
    // Aplanado TKT-1575 Fase 2 (2026-09-02): import/product/type/place eran sub-objetos
    // (2 niveles de anidamiento). Prefijo camesortlCase por sub-grupo, mismo patrón que
    // approval_history.status_* en forms.js — evita colisión entre las 3 claves
    // repetidas (addTitle/addButton/placeholder/listTitle) de product/type/place.
    importTitle: 'Importar catálogo',
    importButton: 'Importar catálogo',
    importNote: '*El archivo cuenta con más de 1 columna.',
    importSuccess: 'Catálogo importado con éxito',
    importError: 'No se pudo importar el catálogo',
    importSkipped: 'Filas ignoradas sin descripción: {count}',
    productAddTitle: 'Agregar un Nuevo Producto',
    productAddButton: 'Agregar Producto',
    productPlaceholder: 'Escribe aquí tu Producto..',
    productListTitle: 'Catálogo',
    productSearch: 'Buscar un Producto',
    typeAddTitle: 'Agregar un Tipo de Exhibición',
    typeAddButton: 'Agregar Tipo de Exhibición',
    typePlaceholder: 'Escribe aquí tu Tipo de Exhibición..',
    typeListTitle: 'Tipo de Exhibición',
    placeAddTitle: 'Agregar un Lugar de Exhibición',
    placeAddButton: 'Agregar Lugar de Exhibición',
    placePlaceholder: 'Escribe aquí tu Lugar de Exhibición..',
    placeListTitle: 'Lugar de Exhibición'
  },

  // Labels de la pantalla de configuracion
  settings: {
    title: 'Configuración',
    tabCatalog: 'Catálogo',
    tabExhibition: 'Exhibición'
  }
}
